module.exports = __webpack_public_path__ + "static/media/bag-o.02c2e114.png";